import { Slide } from "@jelly/lesson";
import theory from "../../theory";
import config from "appConfig";

const principle: Slide = {
  description:
    "In this section you are able to modify a signal consisting of three sinusoidal signals (a Fourier series), as introduced in Section 2. Start by selecting the fundamental frequency and then modify the amplitudes and phases of the different harmonics to observe their effect on the waveform.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "iframe",
            options: {
              src: `${config.IFRAMES_REACT_URL}/0402/`,
            },
          },
        },
      },
    },
  },
};

export default principle;
